module.exports = {
	"postTitle": {
		"cs-CZ": "adventní a vánoční koncerty 2025",
		"en-GB": "Advent and Christmas concerts 2025",
		"fr-FR": "concerts de l'Avent et de Noël 2025",
		"de-DE": "Advent- und Weihnachtskonzerte 2025"
	},
	"text01": {
		"cs-CZ": "Musica pro Sancta Cecilia Vás zve na své letosní adventni a vánoční koncerty. Uslyšíte především písně renesance a baroka.",
		"en-GB": "Musica pro Sancta Cecilia invites you to its Advent and Christmas concerts this year. You will hear mainly songs from the Renaissance and Baroque periods.",
		"fr-FR": "Musica pro Sancta Cecilia vous invite à ses concerts de l'Avent et de Noël cette année. Vous entendrez principalement des chansons de la Renaissance et du Baroque.",
		"de-DE": "Musica pro Sancta Cecilia lädt Sie in diesem Jahr zu seinen Advent- und Weihnachtskonzerten ein. Sie werden hauptsächlich Lieder aus der Renaissance und dem Barock hören."
	},
	"text02": {
		"cs-CZ": "Sobota 20. prosince 2025 v 17 hodin v kostele sv. Michala v Jirchářích",
		"en-GB": "Saturday 20 December 2025 at 5 pm at the Church of St. Michala v Jirchářích.",
		"fr-FR": "Samedi 20 décembre 2025 à 17 heures à l'église Saint-Michala v Jirchářích.",
		"de-DE": "Samstag, 20. Dezember 2025 um 17 Uhr in der Kirche St. Michala v Jirchářích."
	},
	"text03": {
		"cs-CZ": "Neděle 11. ledna 2026 v 16 hodin v kostele sv. Terezie od Dítěte Ježíše, Kobyliské náměstí 1, Praha 8",
		"en-GB": "Sunday, 11 January 2026 at 4 pm at the Church of St. Teresa of the Child Jesus, Kobyliské náměstí 1, Prague 8.",
		"fr-FR": "Dimanche 11 janvier 2026 à 16 heures à l'église Sainte-Thérèse de l'Enfant-Jésus, place Kobyliské 1, Prague 8.",
		"de-DE": "Sonntag, 11. Januar 2026 um 16 Uhr in der Kirche St. Theresia vom Kinde Jesu, Kobyliské Platz 1, Prag 8."
	},
	"text04": {
		"cs-CZ": "Vstupné je dobrovolné.",
		"en-GB": "The entrance fee is voluntary.",
		"fr-FR": "L'entrée est volontaire.",
		"de-DE": "Der Eintritt ist freiwillig."
	},
	"text05": {
		"cs-CZ": "Koncerty budou přenášeny na: ",
		"en-GB": "The concerts will be streamed on:",
		"fr-FR": "Les concerts seront retransmis en streaming sur :",
		"de-DE": "Die Konzerte werden im Internet übertragen:"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post06/Post06.json
// module id = 90
// module chunks = 0